import { render, staticRenderFns } from "./StudentShow.vue?vue&type=template&id=1277e2a2&scoped=true"
import script from "./StudentShow.vue?vue&type=script&lang=js"
export * from "./StudentShow.vue?vue&type=script&lang=js"
import style0 from "./StudentShow.vue?vue&type=style&index=0&id=1277e2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277e2a2",
  null
  
)

export default component.exports